import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { Toast } from '../types/models.ts';
import endpoints from '../endpoints.ts';
import api from '../api/index.ts';

export const SETTINGS_MUTATION_KEY = 'SETTINGS_MUTATION_KEY';

const useExportData = (
  params: {
    customerLocationId: number | string;
    startDate?: string;
    endDate?: string;
  },
  options?: Partial<UseMutationOptions<Toast | null>>
) => {
  return useMutation({
    mutationKey: [
      SETTINGS_MUTATION_KEY,
      endpoints.settings.create.one.dataExport(),
      params,
    ],
    mutationFn: () => api.settings.create.one.dataExport(params),
    ...options,
  });
};

const settingsMutationHooks = {
  useExportData,
};

export default settingsMutationHooks;
